import { Injectable } from '@angular/core';
import { _BalonMLSdkWrapperService } from '@app/core/services/balon-ml-sdk-wrapper/balon-ml-sdk-wrapper.service';

@Injectable({ providedIn: 'root' })
export class MlCdnManagementService {
  constructor(private sdk: _BalonMLSdkWrapperService) {}

  authorizeCdn() {
    this.sdk.mlCdnManager.authorizeCdn();
  }

  deAuthorizeCdn() {
    this.sdk.mlCdnManager.deauthorizeCdn();
  }
}
